import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'languageDisplay',
})
export class LanguageDisplayPipe implements PipeTransform {
    transform(value?: string): string {
        if (!value) {
            return '';
        }

        const cleaned = value.replace(' (Mexican)', '');

        return cleaned;
    }
}
